import * as React from 'react';
import { observer } from 'mobx-react';
import { Card } from '@/elements/shared/Card/Card';
import Tooltip from '@/ui-kit/components/Tooltip/Tooltip';

import { AttributeCfgUIElement } from '@/elements/attributes/AttributeLayout';
import classNames from 'classnames';
import { IntegerAttributeState } from './IntegerAttributeState';

interface Props {
  state: IntegerAttributeState;
}

export const IntegerAttributeCfgUIElement = observer(function IntegerAttributeCfgUIElement({ state }: Props) {
  const { uiControl } = state.viewElement;
  const itemOptions = uiControl.itemOptions;
  const cardOrientation = uiControl.cardType === 'grid' ? 'vertical' : 'horizontal';
  if (!state.visible) {
    return null;
  }

  return (
    <AttributeCfgUIElement state={state}>
      <ul
        className={classNames('cp-attribute__options', uiControl.cardType === 'grid' && 'cp-attribute__options--card')}
      >
        {state.availableValues.map((value) => {
          const isSelected = state.value === value;
          const text = state.textData.values.find((it) => it.value == value);
          const hasTooltip = itemOptions?.showLongDescription && !!text?.detailedDescription;

          return (
            <li key={value} className={'cp-attribute__option'}>
              <Tooltip disabled={!hasTooltip} title={text?.label ?? ''} description={text?.detailedDescription}>
                {(onOpen) => (
                  <Card
                    orientation={cardOrientation}
                    value={value}
                    onSelect={state.setValue}
                    selected={isSelected}
                    // A falsy `0` previously fell through as a number and left the card
                    // untitled; keep that rather than promoting it to the string "0".
                    label={itemOptions?.showTitle ? text?.label || (value ? String(value) : '') : ''}
                    imageSrc={itemOptions?.showImage ? text?.image?.url : undefined}
                    imageFit={itemOptions?.imageFit}
                    imageType="icon"
                    description={itemOptions?.showDescription ? text?.description : ''}
                    hasTooltip={hasTooltip}
                    onTooltipClick={onOpen}
                  />
                )}
              </Tooltip>
            </li>
          );
        })}
      </ul>
    </AttributeCfgUIElement>
  );
});
